const configureSmartGate = async ({
    worldContract,
    smartObjectId,
    systemId
  }: {
    worldContract: any;
    smartObjectId: string;
    systemId: string;
  }): Promise<string | undefined> => {
    let txHash;
  
    txHash = await worldContract.write.eveworld__configureSmartGate([smartObjectId, systemId]);

    return txHash;
  };
  
  export default configureSmartGate;
  